/**
 * ======= Phome number functions =======
 */

// Value operations
const recallValue = (e) => {
  const event = e;
  event.target.value = event.target.dataset.origin;
  event.target.setSelectionRange(event.target.dataset.position, event.target.dataset.position);
};

const emptyValue = (e) => {
  const event = e;
  event.target.dataset.origin = '';
  event.target.dataset.position = 0;
  event.target.dataset.input = '';
  recallValue(event);
};

const formatValue = (e) => {
  const event = e;
  const format = '(###) ### - ####';
  const spaceholder = '_';
  const numbers = event.target.value.replace(/\D/g, '').split('');

  event.target.value = format.split('').reduce((f, char) => {
    let formatted = f;

    if (char === '#') {
      formatted += numbers.shift() || spaceholder;
    } else {
      formatted += char;
    }

    return formatted;
  }, '');
};

// Cursor operations
const correctCursorPosition = (event) => {
  const lastNumber = event.target.value.match(/\d\D*$/);
  const lastNumberPosition = lastNumber ? Number(lastNumber.index) + 1 : 0;
  const oneNumberLeft = !event.data && lastNumberPosition === 2;
  let newPosition;

  newPosition = Math.max(event.target.selectionStart, oneNumberLeft ? 1 : 2);
  newPosition = Math.min(lastNumberPosition, newPosition);
  event.target.setSelectionRange(newPosition, newPosition);
};

const moveForward = (event) => {
  let newPosition = parseInt(event.target.dataset.position, 10) + 1;

  if (newPosition > 4 && newPosition < 7) newPosition = 7;
  if (newPosition > 9 && newPosition < 13) newPosition = 13;

  event.target.setSelectionRange(newPosition, newPosition);
};

const moveBackward = (event) => {
  let newPosition = parseInt(event.target.dataset.position, 10) - 1;

  if (newPosition > 4 && newPosition < 7) newPosition = 4;
  else if (newPosition > 9 && newPosition < 13) newPosition = 9;

  event.target.setSelectionRange(newPosition, newPosition);
};

const stay = (event) => {
  let newPosition = parseInt(event.target.dataset.position, 10);

  if (newPosition > 3 && newPosition < 6) newPosition = 4;
  else if (newPosition > 8 && newPosition < 12) newPosition = 9;

  event.target.setSelectionRange(newPosition, newPosition);
};

/**
 * ======= Module =======
 */
export default {
  formatToPhone(event) {
    // ------ No number in value -------
    if (!event.target.value.match(/\d/)) {
      emptyValue(event);
      return;
    }

    // ------- No space to type -------
    if (event.target.value.replace(/\D/g, '').length > 10) {
      recallValue(event);
      return;
    }

    // ------ Typed Backspace -------
    if (['Backspace'].includes(event.target.dataset.input)) {
      formatValue(event);
      moveBackward(event);
      correctCursorPosition(event);
      return;
    }

    // ------ Typed Delete -------
    if (['Delete'].includes(event.target.dataset.input)) {
      formatValue(event);
      stay(event);
      correctCursorPosition(event);
      return;
    }

    // ------- Typed a character -------
    formatValue(event);
    moveForward(event);
    correctCursorPosition(event);
  },

  formatToEmail(e) {
    const event = e;

    // ------ Typed Backspace -------
    if (event.target.dataset.input === 'Backspace') {
      return;
    }

    // ------ Typed Delete -------
    if (event.target.dataset.input === 'Delete') {
      return;
    }

    // Valid character
    if (/[a-zA-Z0-9_.@]/.test(event.data)) {
      return;
    }

    // Invalid character typed
    // remove the character
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9_.@]/g, '');

    // Reset cursor
    const { position } = event.target.dataset;
    event.target.setSelectionRange(position, position);
  },
};
